module.exports = __webpack_public_path__ + "media/sf_outch.3a2cc7ea.mp3";